import { Injectable } from '@angular/core';
import { GridType } from '../../enums/grid-type.enum';
import { LocalStorageService } from 'angular-2-local-storage';
import {GridFilterCondition} from '../../models/src/gridFilterCondition/grid-filter-condition';
import * as _ from 'lodash';

@Injectable()
export class GridFilterService {

    constructor(private localStorageService: LocalStorageService ) { }


    getGridHeaderCond(type: GridType ): GridFilterCondition  {

        const key = global['loginUser'].curCmpnId + '_' + global['loginUser'].userId + '_' + type;
        const condition: GridFilterCondition = <GridFilterCondition>this.localStorageService.get(key);

        if ( condition == null )  {
            const obj: GridFilterCondition = new GridFilterCondition();
            this.localStorageService.set(key, obj);
            return obj;
        }

        return condition;
    }

    setGridHeaderCond(type: GridType, condition: GridFilterCondition) {

        const key = global['loginUser'].curCmpnId + '_' + global['loginUser'].userId + '_' + type;

        this.localStorageService.set(key, condition);
    }

    updateGridHeaderCond( condition: GridFilterCondition, columns: Array<any> ) {

        // update filter condtion
        const self = columns;

        const filters = (condition.filteringStr != null) ? _.split(condition.filteringStr, '&') : [];
        const sortInfo = (condition.oidx != null ) ? _.split(condition.oidx, ':') : [];

        _.forEach(filters, function(value) {
            /*console.log(value);*/
            const filterCtd = _.split(value, /=|,/);
            const targetObj = _.find(self, function(o) { return o.code === filterCtd[0]; });
            const targetCodes = _.slice(filterCtd, 1);
            //console.log('filterCtd', filterCtd, 'targetObj', targetObj, 'targetCodes', targetCodes);

            _.forEach(targetCodes, function(o){
                try {
                    _.forEach(targetObj.filtering.data, function(t) {
                        if (t['code'] + '' === o) {
                            t['isChecked'] = true;
                            //console.log('founded t', t);
                        }
                        /*
                        if (t.code + '' === o) {
                            t.isChecked = true;
                            //console.log('founded t', t);
                        }
                        */

                    });
                } catch (ex) {
                    console.error(ex);
                }

            });
        });

        _.forEach(columns, function(column) {
            // check sort info
            if ( sortInfo != null && column.name ===  sortInfo[0] ) {
                column.sort = sortInfo[1];
            }
        });

    }

    removeGridHeaderCond(type: GridType) {

        const key = global['loginUser'].curCmpnId + '_' + global['loginUser'].userId + '_' + type;

        this.localStorageService.remove(key);
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/src/grid-filter.service.ts